import { DatePicker, Space, Button, Divider } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
  return (
    <div style={{ padding: 12, width: 280 }}>
      <RangePicker
        style={{ width: "100%" }}
        value={selectedKeys[0]}
        onChange={(dates) => {
          if (dates) {
            setSelectedKeys([dates]); // store selected range
          } else {
            setSelectedKeys([]);
          }
        }}
        format="YYYY-MM-DD"
        allowClear
      />

      <Divider style={{ margin: "8px 0" }} />

      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          icon={<ReloadOutlined />}
          size="small"
          onClick={() => {
            clearFilters();
            confirm();
          }}
        >
          Reset
        </Button>
        <Button type="primary" icon={<FilterOutlined />} size="small" onClick={() => confirm()}>
          Apply
        </Button>
      </Space>
    </div>
  );
};

export default DateRangeFilter;
